import React, { Component } from "react";
import { moment } from 'moment';
import { connect } from 'react-redux';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Grid from '../../common/Grid.jsx';
import { GridColumns } from './EventLogsPageGridColumns';
import { CalculateShiftForLastPageInGrid } from '../../common/Utility';
import { requestEventLogs, requestDownloadFile } from './actions';
import { ASC, DESC, SortedColumnName } from '../../constants/constants';
import Loader from './../../../components/common/loader';

export class EventLogs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            Id: '',
            errorMessage: '',
            correlationId: '',
            uniqueId:'',
            eventCode: '',
            customer: '',
            receiveDate: null,
            timeStampReceiveDate: null,
            historyGridData: [],
            isFilterApplied: false,
            filterState: null,
            Status: null
        };
    }
    componentWillMount() {
        this.props.onRequestEventLogs({
            shift: 0,
            sortingOrder: DESC,
            sortedColumnName: SortedColumnName
        });
    }

    handleIdChange = (event) => {
        this.setState({
            Id: event.target.value
        });
    }
    handleCorrelationIdChange = (event) => {
        this.setState({
            correlationId: event.target.value
        });
    }
    handleEventCodeChange = (event) => {
        this.setState({
            eventCode: event.target.value
        });
    }
    handleCustomerChange = (event) => {
        this.setState({
            customer: event.target.value
        });
    }

    handleuniqueIdChange = (event) => {
        this.setState({
            uniqueId: event.target.value
        });
    }
    handleChange = (date) => {
        this.setState({
            receiveDate: date
        });
    };
    handleDownload(downloadpath) {
        if (downloadpath !== null) {
            this.setState({ isDownloadClicked: true });
            this.props.onRequestDownloadFile(downloadpath);
        }
        else {
            alert("No response received for the file yet !");
            return;
        }
    }

    getEventLogs = (currentShift) => {

        console.log(currentShift);
        const filter = {
            shift: currentShift,
            sortingOrder: this.state.filterState != null ? this.state.filterState.sortingOrder : DESC,
            sortedColumnName: this.state.filterState != null ? this.state.filterState.sortedColumnName : SortedColumnName
        };
        if (this.state.isFilterApplied === true) {
            this.props.onRequestEventLogs({
                shift: currentShift,
                Id: this.state.filterState.Id,
                correlationId: this.state.filterState.correlationId,
                uniqueId: this.state.filterState.uniqueId,
                eventCode: this.state.filterState.eventCode,
                receivedDate: this.state.filterState.receivedDate,
                customer: this.state.filterState.customer,
                sortingOrder: this.state.filterState.sortingOrder,
                sortedColumnName: this.state.filterState.sortedColumnName
            });
        }
        else {
            this.props.onRequestEventLogs(filter);
        }
    }
    handleFilterSelection = () => { 
        const filter = {
            Id: this.state.Id === '' ? null : this.state.Id,
            correlationId: this.state.correlationId === '' ? null : this.state.correlationId,
            uniqueId: this.state.uniqueId === '' ? null : this.state.uniqueId,
            eventCode: this.state.eventCode !== '' ? this.state.eventCode : null,
            receiveTime: this.state.receiveDate,
            customer: this.state.customer !== '' ? this.state.customer : null,
            shift: 0,
            sortingOrder: DESC,
            sortedColumnName: SortedColumnName
        };
        this.setState({ isFilterApplied: true, filterState: filter });
        this.props.onRequestEventLogs(filter);
    };
    resetFilterSection = () => {
        this.setState({
            correlationId: '',
            eventCode: '',
            receivedDate: null,
            customer: '',
            uniqueId: ''
        });
    };
    handlePagination = (direction) => {
        if (direction === "next") {

            if (this.props.eventLogs.PageSize * (this.props.eventLogs.Shift + 1) > this.props.eventLogs.TotalRecords) {
                this.getEventLogs(this.props.eventLogs.Shift);
            }
            else {
                this.getEventLogs(this.props.eventLogs.Shift + 1);
            }
         
        }
        if (direction === "previous") {

            if (this.props.eventLogs.Shift - 1 < 0) {
                this.getEventLogs(this.props.eventLogs.Shift);
            }
            else {
                this.getEventLogs(this.props.eventLogs.Shift-1);
            }
           
        }
        if (direction === "first") {
            this.getEventLogs(0);
        }
        if (direction === "last") {
            this.getEventLogs(CalculateShiftForLastPageInGrid(this.props.eventLogs.TotalRecords / this.props.eventLogs.PageSize));
        }
    };
    handleSorting = (columnName) => {

        const sortingOrder = this.props.eventLogs.sortingOrder;
        const sortedColumnName = this.props.eventLogs.sortedColumnName;
        if (columnName === sortedColumnName) {
            if (sortingOrder === DESC) {
                this.onRequestSorting(sortedColumnName, ASC);
            }
            else {
                this.onRequestSorting(sortedColumnName, DESC);
            }
        }
        else {
            this.onRequestSorting(columnName, ASC);
        }
    };
    onRequestSorting = (columnName, sortingOrder) => {
        const filter = {
            //Id: this.state.Id === '' ? null : this.state.Id,
            correlationId: this.state.correlationId === '' ? null : this.state.correlationId,
            uniqueId: this.state.uniqueId === '' ? null : this.state.uniqueId,
            eventCode: this.state.eventCode !== '' ? this.state.eventCode : null,
            receivedDate: this.state.receiveDate,
            customer: this.state.customer !== '' ? this.state.customer : null,
            sortingOrder: sortingOrder,
            sortedColumnName: columnName
        };
        this.setState({ filterState: filter });
        this.props.onRequestEventLogs(filter);
    }
    render() {
        const Data = this.props.eventLogs !== undefined ? this.props.eventLogs.EventLogs : [];
        const gridCol = GridColumns;
        if (this.props.eventLogs.EventLogs == undefined) {
            return(
        <Loader />)
           // return null; //You can change here to put a customized loading spinner 
        }
        return (
            <div className={"grid-wrapper"}>
                <div className={"grid-wrapper dam-px-4"}>
                    <div className={"col-30"}>
                        <div className="form-group">
                            <label>Correlation Id</label>
                            <input className="form-control" type="text" name="CorrelationId" placeholder="Enter Shipper Booking No., CBL, Container No." value={this.state.correlationId} onChange={this.handleCorrelationIdChange} />
                        </div>
                    </div>
                    <div className="col-30">
                        <div className={"form-group"}>
                            <label className={"form-group"}>Message Trigger</label>
                            <input className="form-control" type="text" name="Message Trigger" placeholder="Enter Message Trigger" value={this.state.eventCode} onChange={this.handleEventCodeChange} />
                        </div>
                    </div>
                    <div className="col-30">
                        <div className={"form-group"}>
                            <label className={"form-group"}>Customer</label>
                            <input className="form-control" type="text" name="Customer" placeholder="Enter Customer" value={this.state.customer} onChange={this.handleCustomerChange} />
                        </div>
                    </div>
                </div>
                <div className={"grid-wrapper dam-px-4"}>
                    <div className={"col-30"}>
                        <div className="form-group">
                            <label>Unique Id</label>
                            <input className="form-control" type="text" name="UniqueId" placeholder="Enter UniqueId" value={this.state.uniqueId} onChange={this.handleuniqueIdChange} />
                        </div>
                    </div>
                    <div style={{marginTop:'80px', float: 'right' }} >
                        <button className="button button-blue" type="button" onClick={this.handleFilterSelection.bind(this)}>Apply</button>
                        <button className="button button-whitle" style={{ marginLeft: '10px' }} type="button" onClick={this.resetFilterSection.bind(this)} >Clear</button>
                      
                        </div>
                </div>
                <div className="filter-button-area">
                    
                </div>
                <div className="voyage-grid-container" style={{ marginTop: '40px' }}>
                    <Grid
                        DataSet={Data}
                        ColumnData={gridCol}
                        IsNested={false}
                        Manual={true}
                        handleSorting={this.handleSorting}
                        onClick={this.handlePagination.bind(this)}
                        TotalRecords={this.props.eventLogs.TotalRecords}
                        DataLimit={this.props.eventLogs.CurrentRecords}
                        StartIndex={this.props.eventLogs.startIndex}
                        EndIndex={this.props.eventLogs.endIndex}
                        noDataText={'No Record Found!'}
                        download={this.handleDownload.bind(this)}
                    />
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        eventLogs: state.GetEventLogsReducers
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        onRequestEventLogs: (filter) => {
            dispatch(requestEventLogs(filter));
        },
        onRequestDownloadFile: (blobPath) => {
            var date = new Date();
            var timeStamp = date.toString().substring(0, 24);
            while (timeStamp.indexOf(" ") > 0) {
                timeStamp = timeStamp.replace(" ", "_");
            }
            dispatch(requestDownloadFile(blobPath, timeStamp));
        }

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventLogs);